@if (stepper.detectionScopeLoading()) {
  <app-loading-spinner size="lg" [framed]="true" [title]="'PROJECT_STEPPER.STEP1.LOADING_TITLE' | translate" [message]="'PROJECT_STEPPER.STEP1.LOADING_MESSAGE' | translate" />
} @else {

  @if (stepper.detectionScopeError()) {
    <div class="mb-6 flex items-center gap-3 rounded px-4 py-3.5 text-sm text-talos-accent"
         style="border:1px solid rgb(var(--talos-accent-rgb) / 0.15);background:rgb(var(--talos-accent-rgb) / 0.04)">
      <span class="w-1.5 h-1.5 rounded-full bg-talos-accent shrink-0"></span>
      {{ stepper.detectionScopeError() }}
    </div>
  }

  <!-- Header strip -->
  <div class="flex items-center justify-between mb-6">
    <p class="text-sm text-talos-ink">
      {{ 'PROJECT_STEPPER.STEP1.SELECT_UP_TO' | translate: { max: stepper.maxDetectionScopeCategories } }}
    </p>
    <div class="flex items-center gap-1.5">
      @for (i of [1, 2]; track i) {
        <div class="w-5 h-5 rounded-full flex items-center justify-center transition-all duration-200"
          [style.background]="i <= stepper.selectedCategories().length ? 'var(--talos-accent)' : 'rgb(var(--talos-ink-rgb) / 0.08)'">
          @if (i <= stepper.selectedCategories().length) {
            <svg class="w-2.5 h-2.5 text-[var(--talos-bg)]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          }
        </div>
      }
      <span class="ml-1 text-[10px] font-bold tabular-nums" style="color:rgb(var(--talos-ink-rgb) / 0.4)">
        {{ stepper.selectedCategories().length }}/{{ stepper.maxDetectionScopeCategories }}
      </span>
    </div>
  </div>

  <!-- Category grid -->
  <div class="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-3">
    @for (cat of stepper.detectionScopeCategories(); track cat.id) {
      <button
        type="button"
        class="category-scope-card relative flex flex-col text-left rounded p-5 h-44 transition-all duration-150 focus:outline-none"
        [disabled]="isDisabled(cat.id)"
        [class.opacity-40]="isDisabled(cat.id)"
        [class.cursor-not-allowed]="isDisabled(cat.id)"
        [class.cursor-pointer]="!isDisabled(cat.id)"
        [style.background]="isSelected(cat.id) ? 'rgb(var(--talos-accent-rgb) / 0.04)' : 'var(--talos-bg)'"
        [style.border]="isSelected(cat.id) ? '1px solid var(--talos-accent)' : isDisabled(cat.id) ? '1px solid rgb(var(--talos-accent-rgb) / 0.1)' : '1px solid rgb(var(--talos-accent-rgb) / 0.16)'"
        (click)="stepper.toggleCategory(cat.id)"
      >
        <!-- Selected accent bar -->
        @if (isSelected(cat.id)) {
          <div class="absolute left-0 inset-y-0 w-[3px] bg-talos-accent rounded-l"></div>
        }

        <!-- Icon + Checkbox -->
        <div class="flex items-start justify-between mb-auto">
          <div class="w-14 h-14 rounded-lg flex items-center justify-center shrink-0 transition-colors"
            [style.background]="isSelected(cat.id) ? 'rgb(var(--talos-accent-rgb) / 0.1)' : 'rgb(var(--talos-ink-rgb) / 0.08)'">
            @if (iconFor(cat); as icon) {
              <span class="category-scope-icon w-9 h-9 shrink-0 transition-colors"
                [class.category-scope-icon--active]="isSelected(cat.id)"
                [style.background]="isSelected(cat.id) ? 'var(--talos-accent)' : 'rgb(var(--talos-ink-rgb) / 0.55)'"
                [style.mask-image]="'url(' + icon + ')'"
                [style.-webkit-mask-image]="'url(' + icon + ')'"
                [attr.aria-label]="categoryLabelKey(cat.id) | translate"
                role="img"
              ></span>
            }
          </div>
          <div class="w-5 h-5 rounded flex items-center justify-center transition-all shrink-0 mt-0.5"
            [style.background]="isSelected(cat.id) ? 'var(--talos-accent)' : 'transparent'"
            [style.border]="isSelected(cat.id) ? 'none' : '1.5px solid rgb(var(--talos-accent-rgb) / 0.22)'">
            @if (isSelected(cat.id)) {
              <svg class="w-2.5 h-2.5 text-[var(--talos-bg)]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            }
          </div>
        </div>

        <!-- Label + description -->
        <div>
          <p class="text-sm font-bold text-talos-ink mb-1 pr-2">{{ categoryLabelKey(cat.id) | translate }}</p>
          <p class="text-[11px] leading-relaxed line-clamp-2" style="color:rgb(var(--talos-ink-rgb) / 0.45)">{{ categoryDescriptionKey(cat.id) | translate }}</p>
        </div>
      </button>
    }
  </div>

}
